import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalReportPage } from 'src/app/model/page/group/iag-portal/iag-portal-reports-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { GroupValidator } from 'src/app/validator/group-validator';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-reports-page',
  templateUrl: './iag-portal-reports-page.component.html',
  styleUrls: ['./iag-portal-reports-page.component.scss']
})
export class IagPortalReportsPageComponent implements OnInit {
  pageName = 'Reports';
  iagPortalsReportsPage: IagPortalReportPage = {} as IagPortalReportPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-reports') {
        this.iagPortalsReportsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalsReportsPage.sections = [];
    this.iagPortalsReportsPage.assetImages = [];
    this.iagPortalsReportsPage.sectionsJustAboveImageReports = [];
    this.iagPortalsReportsPage.sectionsJustBellowImageReports = [];
    this.iagPortalsReportsPage.sectionReportViewSectionAccordion = [];
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((resIncludes) => {
      this.mapBanner(resIncludes.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalsReportsPage.banner);
      this.mapPageInfo(resIncludes.items);
      this.mapSections(resIncludes.includes.Entry);
    });
  }

  private mapBanner(iagPortalsReportsPageEntries: Entry<any>[]) {
    iagPortalsReportsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];

    this.iagPortalsReportsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalsReportsPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalsReportsPage.banner.url = entry.fields?.url;
      this.iagPortalsReportsPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalsReportsPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalsReportsPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalsReportsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(iagPortalsReportsPageEntries: Entry<any>[]) {
    iagPortalsReportsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
        this.mapEntryToJustAboveImageReportsSection(entry);
      });
    this.iagPortalsReportsPage.sectionsJustAboveImageReports = this.iagPortalsReportsPage.sectionsJustAboveImageReports.filter((section) => GroupValidator.isJustAboveIagImageReports(section.group));

    this.iagPortalsReportsPage.sectionsJustBellowImageReports = this.iagPortalsReportsPage.sections.filter((section) => GroupValidator.isJustBelowIagImageReports(section.group));
    this.iagPortalsReportsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title:any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalsReportsPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry?.fields?.['subBody'] as string,
      titleColorClass: entry.fields['sectionClass'] as string
    });
    this.iagPortalsReportsPage.sectionReportViewSectionAccordion = this.iagPortalsReportsPage.sections.filter((section) => section.group === 'report-view-section-accordion');
  }

  private mapEntryToJustAboveImageReportsSection(entry: Entry<any>) {
    let title:any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalsReportsPage.sectionsJustAboveImageReports.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry?.fields?.['subBody'] as string,
      titleColorClass: entry.fields['sectionClass'] as string
    });
  }
}
